































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LoadingContent extends Vue {

  @Prop({ default: false, type: Boolean }) private loading!: boolean;

  @Prop({ default: false, type: Boolean }) private loadError!: boolean;

  @Prop({ default: "", type: String }) private errorMessage!: string;

  private emitTryAgain() {
    this.$emit('try-again');
  }
  
}
